import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const _sectionHeaderClassNames = gridLayout =>
  classnames({ table__header: true }, { 'table__header--grid': gridLayout });

const _headerClassNames = (
  gridLayout,
  { columnSize, columnAlign },
  className
) =>
  classnames(
    'table__header__title',
    `table__header__title--${columnSize}`,
    `table__header__title--${columnAlign}`,
    { 'table__header__title--grid': gridLayout },
    className
  );

const TableHeader = ({ headers, gridLayout, className }) => (
  <section
    className={_sectionHeaderClassNames(gridLayout)}
    data-testid='tableHeader'
  >
    {headers &&
      headers.map(header => (
        <p
          key={header.label}
          className={_headerClassNames(gridLayout, header, className)}
        >
          {header.label}
        </p>
      ))}
  </section>
);

TableHeader.propTypes = {
  headers: PropTypes.array,
  gridLayout: PropTypes.bool,
  className: PropTypes.string
};

export default TableHeader;
